<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>研究工具</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div>
          <template>
                <div style="min-height:600px;">

                  <div v-for="soft in softlist" :key="soft">

                      <div class="tg-row">
                      <div class="soft-img">
                        <img style="width:210px;height:210px;" :src="sourceurl+soft.front_img_url" alt="">
                      </div>
                      <div class="soft-content">
                        <div class="soft-title">
                          <div >{{soft.soft_name}}</div>
                        </div>
                        <div  class="soft-detail">
                          <div >{{soft.soft_info}}</div>
                        </div>
                      </div>
                      <div class="wytg-btn">
                        <div class="btn-div" @click="opento(soft.soft_url)">下载</div>
                      </div>
                    </div>

                    </div>
                 

                </div>
                

                <div style="width:1150px; margin-bottom:10px;">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


              </template>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      //totaldata:'99999',
      softlist:[],
      sourceurl:'',
      tableData:[],
      totaldata:'99999',
      currrentpage:1,
      pageSize:20,
      totalcount:100,
      searchtxt:'',
      uid:0,
    };
  },
  methods: {

    current_change(val){
      this.currrentpage=val;
      this.submitform();
      //this.retrieval();
    },
    size_change(val){
      this.pageSize=val;
      this.submitform();
    },
    submitform(){
      //alert('sunbmitform');

      //this.uid=window.sessionStorage.getItem('hguid');
      this.sourceurl=`${this.$store.state.sourceurl}../..`;
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgtool/gettoollist?searchtxt=`+this.searchtxt+'&cpage='+this.currrentpage+'&psize='+this.pageSize)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.softlist=pinfo.data;
        this.totalcount=pinfo.dataSize;
        console.log("sssss"+this.softlist);
        
      });
    },



    opento(url){
      window.open(url,'_blank');

    },
    //点击搜索按钮
    btnsearch(){

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    //获取当前条目ID号
    this.sourceurl=`${this.$store.state.sourceurl}../..`;
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgtool/gettoollist?searchtxt=`+this.searchtxt+'&cpage='+this.currrentpage+'&psize='+this.pageSize)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.softlist=pinfo.data;
        this.totalcount=pinfo.dataSize;
        //console.log("sssss"+this.softlist[0][id]);
        
      });
  },
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.tg-row{
      margin-top: 30px;
      margin-left: 30px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      border-block-end: 1px dashed  #ddd;
      .soft-img{
        width:210px;
        height: 210px;
      }
      .soft-content{
        padding-left: 25px;
        width: 800px;
        .soft-title{
          margin-top: 10px ;
          margin-bottom: 10px;
          text-align: left;
          color: #333333;
          font-size: 20px;
          font-weight: 600;

        }
        .soft-detail{
          color: #333333;
          margin-left: 15px;
          margin-right: 15px;
          text-align: left;

        }
      }
      .wytg-btn{
        padding-left: 10px;
        width: 120px;
        .btn-div{
          cursor:pointer;
          padding-top: 10px;
          margin-top: 170px;
          width: 120px;
          height: 35px;
          color: #ffffff;
          background-color: #c60828 ;
        }
          
      }
}

.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .c-row{
    width:1100px;
    margin-left: auto;
    margin-right: auto;
    .el-button{
      color: #ffffff;
      width: 90px;
      height: 40px;
      float: right;
      margin: 20px;
      border-radius: 5px;
      background-color: #c60828;

    }
  }
  
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.my-table{
  margin-left: auto;
  margin-right: auto;
  .my-tbody{
    display: table-row-group;
    vertical-align: middle;
    width: 1100px;
    
    tr {
        display: table-row;
        vertical-align: inherit;
        th {
          display: table-cell;
          vertical-align: inherit;
          font-weight: bold;
          text-align: left;
          height: 50px;
          border: none;
          background-color: #d4c9bc;
      }
        td {
          display: table-cell;
          vertical-align: inherit;
          text-align: left;
          height:80px;
      }
    }

  }
}






</style>